<template>
    <div class="talentInfo">
      <Search :title="name">
        <div class="test_result">
          <p class="test_result_title">检测结果</p>
          <div class="test_result_title_result">
            <p class="test_result_message">{{ summary }}</p>
            <p class="test_result_info">{{ explain }}</p>
          </div>
        </div>

        <div class="box">
          <van-tabs v-model="activeTab" style="border: none;">
            <van-tab title="关注基因">
              <GeneList isshow="talent" :data="gene_list"></GeneList>
            </van-tab>
            <van-tab title="参考文献">
              <div v-if="gdb3">
                <Paper :data="documents" :fake="fake_gene" :single="single"></Paper>
              </div>
              <div v-if="gdb2">
                <div class="paper">
                  <p style="text-align: center">暂无文献</p>
                </div>
              </div>
            </van-tab>
          </van-tabs>
        </div>

        <div class="disease-content">
          <div class="title">
            <i class="iconfont iconrenqundingyi blue"></i>
            <p>人群分布比例</p>
          </div>
          <div class="box-body">
            <canvas class="gk-chart" ref="pieChart2" width="600" height="500"></canvas>
            <div class="pie-text" v-if="gdb3">
              <p v-for="(item, index) in rate_list" :key="index" :style="{ color: colors[index] }">
                <i class="iconfont icon-dui" v-if="item.rate_title === summary"></i>
                {{ item.rate_title }}: <span style="float: right;">{{ (item.rate * 100).toFixed(2) }}%</span>
              </p>
            </div>
            <div class="pie-text" v-if="gdb2">
              <p v-for="(item, index) in rate_list" :key="index" :style="{ color: colors[index] }">
                <i class="iconfont icon-dui" v-if="item.conclusion === summary"></i>
                {{ item.conclusion }}: <span style="float: right;">{{ (item.rate * 100).toFixed(2) }}%</span>
              </p>
            </div>
          </div>

          <ExpandableText icon="iconleshenghuo" color="gray" title="生活建议" :text="advice"></ExpandableText>
          <ExpandableText icon="icongouwuxiaotieshi" color="orange" title="小贴士" :text="desc"></ExpandableText>
        </div>

        <div v-if="gdb3">
          <Pagination url="talentInfo" :id="id"></Pagination>
        </div>
      </Search>
    </div>
</template>

<script>
import Search from '@/components/Search'
import ExpandableText from '@/components/ExpandableText'
import GeneList from '@/components/GeneList'
import Paper from '@/components/Paper'
import Pagination from '@/components/Pagination'
export default {
  name: 'talentInfo',
  data () {
    return {
      gdb3: false,
      gdb2: false,
      activeTab: 0,
      id: this.$route.params.id,
      name: '', // 特质基因名称
      system: '', // 系统分类名称
      summary: '', // 检测结论
      explain: '', // 对检测结论的解释
      gene_list: [], // 基因列表
      rate_list: [], // 人群分布数据
      documents: [], // 参考文献
      single: '', // XY同源染色体判断结果
      fake_gene: '', // 假基因
      advice: '', // 生活建议
      desc: '', // 小贴士
      multiple: 3, // 3倍缩放， 使 canvas 更清晰
      sicknessRate: [0, 0], // 顺序是 高 低
      tag: 0,
      colors: ['#D63040', '#538ECD', '#A349A4', '#FF7F27', '#7092BE', '#FFAEC9']
    }
  },
  methods: {
    drawPieChart2 () {
      let multiple = this.multiple
      let pieChart1 = this.$refs.pieChart2
      let ctx = pieChart1.getContext('2d')
      let cx = pieChart1.width / 2
      let cy = pieChart1.height / 2
      let cr = 80 * multiple
      let sicknessRate = this.sicknessRate
      let startDeg = 1.5 * Math.PI // 存放每次的起始角度
      let color = this.colors
      let sum = 0
      ctx.font = (14 * multiple) + 'px Arial'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      for (let i = 0, len = sicknessRate.length; i < len; i++) {
        sum += sicknessRate[i]
      }
      if (sum < 100) {
        sicknessRate.push(100 - sum)
        color.push('#79CC0F')
      }
      let endDegs = []
      for (let i = 0, len = sicknessRate.length; i < len; i++) {
        ctx.fillStyle = color[i]
        let endDeg = sicknessRate[i] / 100 * 2 * Math.PI
        endDegs.push(endDeg)
        ctx.beginPath()
        ctx.moveTo(cx, cy)
        ctx.arc(cx, cy, cr, startDeg, startDeg + endDeg, false)
        ctx.fill()
        startDeg = startDeg + endDeg
      }
    },
    getTalentDetails () {
      this.util.get(this.api.talent_details + '?id=' + this.id, '', (success) => {
        this.name = success.details.name
        this.system = success.details.system
        this.summary = success.details.summary
        this.explain = success.details.explain
        this.gene_list = success.details.gene_list
        this.rate_list = success.details.rate_list
        this.documents = success.details.documents
        if (success.details.fake_gene) {
          this.fake_gene = success.details.fake_gene
        }
        if (success.details.single) {
          this.single = success.details.single
        }
        this.desc = success.details.desc
        this.advice = success.details.advice
        this.sicknessRate = success.details.rate_list.map(item => {
          return item.rate * 100
        })
        this.drawPieChart2()
      })
    },
    // gdb2
    getTalentDetails1 () {
      this.util.get1(this.api.talentDetails + '?itemid=' + this.id, '', (success) => {
        this.name = success.chname
        this.summary = success.conclusion
        this.explain = success.explain
        this.gene_list = success.gene
        this.rate_list = success.distribution
        this.documents = success.paper
        this.desc = success.traits_desc
        this.advice = success.advice
        this.sicknessRate = success.distribution.map(item => {
          return item.rate * 100
        })
        this.drawPieChart2()
      })
    }
  },
  mounted () {
    if (this.util.getLS(this.api.status) === 1) {
      this.gdb3 = true
      this.getTalentDetails()
    } else {
      this.gdb2 = true
      this.getTalentDetails1()
    }
  },
  watch: {
    '$route' (to) {
      this.id = parseInt(to.params.id)
      this.getTalentDetails()
    }
  },
  components: {
    Search,
    ExpandableText,
    GeneList,
    Paper,
    Pagination
  }
}
</script>

<style lang="scss">
  @import "../../assets/scss/functions";
  .talentInfo {

    .test_result {
      margin-top: 0;
    }
    .paper {
      color: #000;
      padding: pxToRem(30px);
    }
  }

  .pie-text {
    p {
      padding-left: 20px;
      position: relative;
      overflow: hidden;
    }
    .icon-dui {
      position: absolute;
      left: 0;
      top: 3px;
    }
    .active {
      color: #ea593f;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/talent/talentInfo.vue